import { createStyles, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import logo from './icon-logo.svg';

type Props = {

}

export const FlutterHero = (props: Props) => {
    const classes = useStyles({});
    return <div className={classes.hero} style={{
        backgroundImage: 'url("/images/banner.jpg")',
    }}>
        <div className={classes.content}>
            <div className={classes.logo}>
                <img src={logo} alt='Flutter logo' />
            </div>
            <Typography variant='h5' style={{
                textTransform: 'uppercase'
            }} align='center' gutterBottom><strong>Spark Authentic Connections</strong></Typography>
        </div>
    </div>
}

const useStyles = makeStyles(theme => createStyles({
    hero: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        height: '60vh',
        background: 'rgba(0, 0, 0, .3)',
        padding: theme.spacing(2),
    },
    logo: {
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
        '& img': {
            width: '100%'
        }
    },
}))